import { combineReducers } from 'redux';

import applicationReducer, {
  initialState as appInitialState,
} from 'modules/application';

import commonReducer, {
  initialState as commonInitialState,
} from 'modules/common';

import accountReducer, {
  initialState as accountInitialState,
} from 'modules/account';

export const initialState = {
  application: appInitialState,
  account: accountInitialState,
  common: commonInitialState,
};

const rootReducer = combineReducers({
  application: applicationReducer,
  account: accountReducer,
  common: commonReducer,
});

export default rootReducer;
